module.exports = "/fonts/opensans.woff";